import { useContext } from "react";
import { BindingError } from "../BindingError.js";
import { EntityKeyContext } from "./EntityKeyContext.js";
const useEntityKey = () => {
  const entityKey = useContext(EntityKeyContext);
  if (entityKey === void 0) {
    throw new BindingError(
      `Trying to use a data bound component outside a correct parent. You likely forgot to use <DataBindingProvider /> or a SubTree.`
    );
  }
  return entityKey;
};
export {
  useEntityKey
};
//# sourceMappingURL=useEntityKey.js.map
